import { Navigate, useParams } from "react-router-dom";
import { CASE_STUDIES } from "@/lib/cases";
import { CaseHero } from "@/components/work/CaseHero";
import { ScreenGallery } from "@/components/work/ScreenGallery";
import { StatsBand, Problem, Research, Approach, DesignSystem, Hard, Results } from "@/components/work/CaseSections";
import { NextCase } from "@/components/work/NextCase";
import { CTA } from "@/components/site/CTA";

export default function CaseStudy() {
  const { slug } = useParams();
  const c = CASE_STUDIES[slug];
  if (!c) return <Navigate to="/" replace />;
  return (
    <main data-testid={`case-page-${c.slug}`} style={{ "--case": c.accent }}>
      <CaseHero c={c} />
      <div className="mt-24"><StatsBand stats={c.stats} /></div>
      <Problem p={c.problem} />
      <Research r={c.research} />
      <Approach a={c.approach} />
      {c.system && <DesignSystem s={c.system} />}
      <ScreenGallery c={c} />
      <Hard h={c.hard} />
      <Results r={c.results} />
      <NextCase c={CASE_STUDIES[c.next]} />
      <CTA />
    </main>
  );
}
